// @ts-nocheck
/* eslint-enable */
import React from 'react';
import assign from 'lodash/assign';
import { connect } from 'react-redux';
import styled from 'styled-components';
import cx from 'classnames';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import IconArrowLeft from 'images/icons/arrow-left.svg';
import IconArrowRight from 'images/icons/arrow-right.svg';
import routeUtils from 'app/shared/utils/routeUtils';
import Container from 'app/shared/core/Container';
import Linker from 'app/shared/modules/Linker';
import queryUtils from 'app/shared/utils/queryUtils';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('modules/pagination');
const { number, func, object, string } = PropTypes;
const StyledHalfDiv = styled.div`
  display: inline-block;
  width: 50%;
  vertical-align: top;
  ${(props) => props.rightAlignText && `text-align: right;`}
`;
class Pagination extends React.Component {
  static propTypes = {
    prevLink: string,
    nextLink: string,
    maxItemsPerPage: number,
    onClick: func,
    totalItems: number,
    // From react-router
    location: PropTypes.shape({
      query: object,
      pathname: string,
    }),
  };

  static defaultProps = {
    prevLink: 'Prev',
    nextLink: 'Next',
    maxItemsPerPage: 10,
    onClick: () => {},
    totalItems: 0,
  };

  linkTo = (path, query, offset) => {
    // Only use query parameter start=n if n != 0 (because ?start=0 is default)
    let newQuery = omit(query, 'start');

    if (offset !== 0) {
      newQuery = assign(newQuery, { start: offset });
    }

    return routeUtils.buildPathWithQuery(path, newQuery);
  };

  render() {
    const {
      prevLink,
      nextLink,
      maxItemsPerPage,
      totalItems,
      onClick,
      location: { search, pathname },
    } = this.props;
    const query = queryUtils.parse(search);

    if (totalItems <= maxItemsPerPage) {
      return null;
    }
    const offset = parseInt(query.start, 10) || 0;
    const nextOffset = offset + maxItemsPerPage;
    const prevOffset = Math.max(0, offset - maxItemsPerPage);
    const linkToPrevPage = this.linkTo(pathname, query, prevOffset);
    const linkToNextPage = this.linkTo(pathname, query, nextOffset);
    const canGoBack = offset > 0;
    const canGoForward = nextOffset <= totalItems;
    logger?.debug(
      {
        maxItemsPerPage,
        totalItems,
        offset,
        nextOffset,
        prevOffset,
        linkToPrevPage,
        prevLink,
        nextLink,
        linkToNextPage,
        canGoBack,
        canGoForward,
      },
      'Pagination',
    );

    return (
      <Container className={cx('Pagination', this.props.className)}>
        <StyledHalfDiv>
          {' '}
          {canGoBack && (
            <Linker to={linkToPrevPage} onClick={() => onClick(prevOffset)} linkType="accent">
              <img src={IconArrowLeft} height="12px" width="12px" alt="" /> {prevLink}
            </Linker>
          )}
        </StyledHalfDiv>

        <StyledHalfDiv rightAlignText>
          {' '}
          {canGoForward && (
            <Linker to={linkToNextPage} onClick={() => onClick(nextOffset)} linkType="accent">
              {nextLink} <img src={IconArrowRight} height="12px" width="12px" alt="" />
            </Linker>
          )}
        </StyledHalfDiv>
      </Container>
    );
  }
}

export default connect()(Pagination);
